(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-size-chart"] && !Shopify.designMode) return;
  try {
    if (!window.eagleSizeChartInitialized) {
      window.eagleSizeChartInitialized = true;

      const sizeNames = new Map([
        ['XXXS', ['3X-Small', '3XS']], ['3XS', ['3X-Small', '3XS']],
        ['XXS', ['2X-Small', '2XS']], ['2XS', ['2X-Small', '2XS']],
        ['XS', ['X-Small', 'XS']], ['XSMALL', ['X-Small', 'XS']],
        ['S', ['Small', 'S']], ['SMALL', ['Small', 'S']],
        ['M', ['Medium', 'M']], ['MEDIUM', ['Medium', 'M']],
        ['L', ['Large', 'L']], ['LARGE', ['Large', 'L']],
        ['XL', ['X-Large', 'XL']], ['XLARGE', ['X-Large', 'XL']],
      ]);

      const normalizeSizeKey = (value) => value.toUpperCase().replace(/[^A-Z0-9]/g, '');

      const canonicalSize = (value) => {
        const key = normalizeSizeKey(value);
        if (sizeNames.has(key)) return sizeNames.get(key);
        const repeatedXLarge = key.match(/^(X{2,10})L$/);
        if (repeatedXLarge) {
          const count = repeatedXLarge[1].length;
          return [`${count}X-Large`, `${count}XL`];
        }
        const numbered = key.match(/^(\d{1,2})X(?:L|LARGE)?$/);
        if (numbered) return [`${numbered[1]}X-Large`, `${numbered[1]}XL`];
        const numberedSmall = key.match(/^(\d{1,2})X(?:S|SMALL)$/);
        if (numberedSmall) return [`${numberedSmall[1]}X-Small`, `${numberedSmall[1]}XS`];
        return [value.trim(), value.trim()];
      };

      const decorateSizeLabel = (cell) => {
        if (!cell || cell.dataset.sizeDecorated === 'true') return;
        const [full, compact] = canonicalSize(cell.textContent);
        cell.textContent = '';
        const fullLabel = document.createElement('span');
        fullLabel.className = 'size-chart-size--full';
        fullLabel.textContent = full;
        const compactLabel = document.createElement('span');
        compactLabel.className = 'size-chart-size--compact';
        compactLabel.textContent = compact;
        compactLabel.setAttribute('aria-hidden', 'true');
        cell.setAttribute('aria-label', full);
        cell.append(fullLabel, compactLabel);
        cell.dataset.sizeDecorated = 'true';
      };

      const parseNumber = (value) => {
        const cleaned = value.replace(/["′″]/g, '').trim();
        const mixed = cleaned.match(/^(\d+)\s+(\d+)\/(\d+)$/);
        if (mixed) return Number(mixed[1]) + Number(mixed[2]) / Number(mixed[3]);
        const fraction = cleaned.match(/^(\d+)\/(\d+)$/);
        if (fraction) return Number(fraction[1]) / Number(fraction[2]);
        const number = Number(cleaned);
        return Number.isFinite(number) ? number : null;
      };

      const parseMeasurement = (value) => {
        const normalized = value.replace(/[–—]/g, '-').replace(/\bto\b/gi, '-').trim();
        if (!normalized || normalized === '—' || normalized === '-') return null;
        const parts = normalized.split(/\s+-\s+|-(?=\d)/).map((part) => parseNumber(part));
        if (parts.some((part) => part === null) || parts.length > 2) return null;
        return parts;
      };

      const greatestCommonDivisor = (a, b) => b ? greatestCommonDivisor(b, a % b) : a;

      const formatInches = (value) => {
        let whole = Math.floor(value);
        let numerator = Math.round((value - whole) * 8);
        if (numerator === 8) {
          whole += 1;
          numerator = 0;
        }
        if (!numerator) return String(whole);
        const divisor = greatestCommonDivisor(numerator, 8);
        const fraction = `${numerator / divisor}/${8 / divisor}`;
        return whole ? `${whole} ${fraction}` : fraction;
      };

      const formatCentimeters = (value) => {
        const rounded = Math.round(value * 10) / 10;
        return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
      };

      const formatRange = (values, unit) => values.map((value) => unit === 'in' ? formatInches(value) : formatCentimeters(value)).join(' - ');

      const cleanHeading = (value) => value
        .replace(/\((?:in\.?|inches|cm|centimeters)\)/gi, '')
        .replace(/\b(?:inches|inch|in\.|centimeters|centimetres|cm)\b/gi, '')
        .replace(/\s+/g, ' ')
        .replace(/[\s:—–-]+$/g, '')
        .trim();

      const headingUnit = (value) => /\b(?:cm|centimeters|centimetres)\b/i.test(value) ? 'cm' : 'in';

      const setHelmetMeasurements = (table) => {
        table.querySelectorAll('tbody tr').forEach((row) => {
          decorateSizeLabel(row.querySelector('th'));
          const inchCell = row.querySelector('[data-measurement-unit="in"]');
          const cmCell = row.querySelector('[data-measurement-unit="cm"]');
          if (!inchCell || !cmCell) return;
          const cmValues = parseMeasurement(cmCell.textContent);
          if (!cmValues) return;
          inchCell.textContent = formatRange(cmValues.map((value) => value / 2.54), 'in');
          cmCell.textContent = formatRange(cmValues, 'cm');
        });
      };

      const enhanceMeasurementTable = (table) => {
        if (!table || table.dataset.unitsEnhanced === 'true') return;
        table.dataset.unitsEnhanced = 'true';
        if (table.dataset.chartType === 'helmet') {
          setHelmetMeasurements(table);
          return;
        }

        const headerRow = table.tHead?.rows[0];
        const bodyRows = [...(table.tBodies[0]?.rows || [])];
        if (!headerRow || !bodyRows.length) return;
        bodyRows.forEach((row) => decorateSizeLabel(row.querySelector('th, td:first-child')));

        const headings = [...headerRow.cells];
        const alreadyDualUnit = headings.some((cell) => /\b(?:cm|centimeters|centimetres)\b/i.test(cell.textContent));
        if (alreadyDualUnit) {
          const units = headings.map((cell) => headingUnit(cell.textContent));
          headings.forEach((cell, index) => {
            if (!index) return;
            const cleaned = cleanHeading(cell.textContent);
            cell.textContent = cleaned || (units[index] === 'cm' ? 'CM' : 'Inches');
          });
          bodyRows.forEach((row) => [...row.cells].slice(1).forEach((cell) => {
            const measurement = parseMeasurement(cell.textContent);
            if (measurement) cell.textContent = formatRange(measurement, units[cell.cellIndex] || 'in');
          }));
          return;
        }

        for (let columnIndex = headings.length - 1; columnIndex >= 1; columnIndex -= 1) {
          const sourceHeader = headings[columnIndex];
          const measurements = bodyRows.map((row) => parseMeasurement(row.cells[columnIndex]?.textContent || ''));
          const measurableCount = measurements.filter(Boolean).length;
          if (!measurableCount || measurableCount < Math.ceil(bodyRows.length * 0.6)) continue;

          const sourceUnit = headingUnit(sourceHeader.textContent);
          const baseHeading = cleanHeading(sourceHeader.textContent) || 'Measurement';
          sourceHeader.textContent = `${baseHeading} (in)`;
          const cmHeader = document.createElement('th');
          cmHeader.scope = 'col';
          cmHeader.textContent = `${baseHeading} (cm)`;
          sourceHeader.after(cmHeader);

          bodyRows.forEach((row, rowIndex) => {
            const sourceCell = row.cells[columnIndex];
            const cmCell = document.createElement('td');
            const measurement = measurements[rowIndex];
            if (measurement) {
              const inchValues = sourceUnit === 'cm' ? measurement.map((value) => value / 2.54) : measurement;
              const cmValues = sourceUnit === 'cm' ? measurement : measurement.map((value) => value * 2.54);
              sourceCell.textContent = formatRange(inchValues, 'in');
              cmCell.textContent = formatRange(cmValues, 'cm');
            } else {
              cmCell.innerHTML = '&mdash;';
            }
            sourceCell.after(cmCell);
          });
        }
      };

      const enhanceDialog = (dialog) => {
        dialog.querySelectorAll('[data-size-chart-table], .size-chart-dialog__page-content table').forEach(enhanceMeasurementTable);
      };
      document.querySelectorAll('dialog.size-chart-dialog').forEach((dialog) => {
        const table = dialog.querySelector('[data-size-chart-table][data-chart-type="universal"]');
        if (!table) return;
        const hasMeasurement = [...table.querySelectorAll('tbody tr')].some((row) =>
          [...row.cells].slice(1).some((cell) => !['', '-', '—'].includes(cell.textContent.trim()))
        );
        if (hasMeasurement) return;
        document.querySelectorAll(`[data-size-chart-open][aria-controls="${dialog.id}"]`).forEach((button) => button.remove());
        dialog.remove();
      });


      document.addEventListener('click', (event) => {
        const openButton = event.target.closest('[data-size-chart-open]');
        const closeButton = event.target.closest('[data-size-chart-close]');

        if (openButton) {
          event.preventDefault();
          const dialog = document.getElementById(openButton.getAttribute('aria-controls'));
          if (dialog && typeof dialog.showModal === 'function') {
            enhanceDialog(dialog);
            dialog.showModal();
          }
        }

        if (closeButton) {
          const dialog = closeButton.closest('dialog');
          if (dialog) dialog.close();
        }

        if (event.target.matches('dialog.size-chart-dialog')) {
          const bounds = event.target.getBoundingClientRect();
          const outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
          if (outside) event.target.close();
        }
      });
    }
  } catch(e) { console.error(e); }
})();

})();
